import React, { useEffect } from "react";
import "./GallerySwiper.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { useState } from "react";

const GallerySwiper = (props) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [swiperSlide, setSwiperSlide] = useState([]);

  useEffect(() => {
    setSwiperSlide(props.GalleryPic);
  }, [props.GalleryPic]);

  return (
    <div className="swiper-gallery-parent">
      <div className="gallerySwiper__">
        <Swiper
          loop={true}
          spaceBetween={10}
          navigation={false}
          thumbs={{ swiper: thumbsSwiper }}
          modules={[FreeMode, Navigation, Thumbs]}
          className="mySwiper2"
        >
          {swiperSlide?.map((v, index) => (
            <SwiperSlide key={index}>
              <img src={v?.url} alt="" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {swiperSlide?.map((v, index) => (
          <SwiperSlide key={"S" + index} className="resize-slide">
            <img src={v?.url} alt="" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
export default GallerySwiper;
